<template>
  <div class="trainer-complex-actions tracoac text-noselect">
    <RaiseSlider
      v-if="!hasResult"
      ref="raiseSlider"
      class="tracoac_slider"
      :class="sliderActive ? 'z-index_2' : 'z-index_0'"
      :actions="raises"
      :readOnly="false"
      @mousedown="sliderActive = true"
      @mouseup="sliderActive = false"
      @update:actions="handleSliderUpdate"
    />

    <TrainerActions
      :actions="visibleActions"
      :grouping
      :hasResult
      :hasChart="false"
      :hasFreq
      :hasEv
      :bettingInfo
      :hasCheatFrequency
      :selectKey
      :hasBetHotkeys
      :loading
      :gridClass="l_gridClass"
      :loadingBtns
      class="z-index_1 position-relative tracoac_actions"
      @click:action="a => $emit('click:action', a)"
    />
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import RaiseSlider from '@/components/RaiseSlider/RaiseSlider'
import TrainerActions from '@/components/Trainer/TrainerActions'
import { getRaisesNonRaises } from '@/helpers/grouping'

export default {
  name: 'TrainerComplexActions',
  components: {
    RaiseSlider,
    TrainerActions,
  },
  mixins: [format_mix],
  props: {
    bettingInfo: Object,
    actions: Array,
    grouping: String,
    hasResult: Boolean,
    hasEv: Boolean,
    hasFreq: Boolean,
    hasChart: Boolean,
    hasBetHotkeys: Boolean,
    gridClass: String,
    allActionsVisible: Boolean,
    hasCheatFrequency: Boolean,
    selectKey: { default: 'is_selected' },
    loading: Boolean,
    loadingBtns: { default: () => 5 },
    active: Boolean,
  },
  emits: ['click:action'],
  data() {
    return {
      sliderActions: [],
      sliderActive: false,
    }
  },
  methods: {
    handleSliderUpdate(actions) {
      if (JSON.stringify(actions) !== JSON.stringify(this.sliderActions)) {
        this.sliderActions = actions
      }
    },
  },
  computed: {
    l_gridClass() {
      const res = this.gridClass || (this.aLength % 2 === 0 ? 'tract_grid_2-5' : 'tract_grid_3')
      // debugger
      return res
    },
    l_actions() {
      const res = this.actions || []
      return res
    },
    raises() {
      const { raises } = getRaisesNonRaises({ actions: this.l_actions })
      return raises
    },
    aLength() {
      const res = this.visibleActions.length
      return res
    },
    visibleActions() {
      if (this.allActionsVisible) {
        return this.l_actions
      }
      let res = this.l_actions.filter(a =>
        a.type === 'RAISE' ? this.sliderActions.some(aa => aa.code === a.code) : true,
      )
      if (this.sliderActions.length === 0) {
        // opponent spot fallback
        const raise = this.raises.find(i => i.is_selected) || this.raises[0]
        res = [...res, raise].filter(i => i)
      }
      const someSelected = this.l_actions.find(i => i.is_selected || i.is_preselected)
      if (someSelected && this.hasResult) {
        const selectedAction = this.l_actions.find(i => i.is_selected || i.is_preselected)
        res = [selectedAction]
      }
      return res
    },
    hotkeys() {
      return this.$store.getters.hotkeys
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    hotkeysPressedBottom(keys) {
      if (!this.active) return
      if (!keys) return
      const hotkeyActions = {
        action_check_fold: {
          keys: this.hotkeys.action_check_fold.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.code === 'X' || i.code === 'F')
            if (a) this.$emit('click:action', a)
          },
        },
        action_call: {
          keys: this.hotkeys.action_call.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.code === 'C')
            if (a) this.$emit('click:action', a)
          },
        },
        action_allin: {
          keys: this.hotkeys.action_allin.keyCombination,
          fn: () => {
            const a = this.l_actions.find(i => i.code === 'RAI')
            if (a) this.$emit('click:action', a)
          },
        },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
  },
}
</script>
<style lang="scss" scoped>
.tracoac {
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-gap: 0.5rem;
  &_actions {
    position: relative;
    order: 2;
  }
  &_slider {
    order: 1;
    width: 75%;
    margin: 0 auto 0 auto;
    position: relative;
  }
}
@media (max-width: 1023px) {
  .tracoac {
    grid-gap: 1rem;
    &_actions {
      order: 1;
    }
    &_slider {
      order: 2;
      width: 100%;
    }
  }
}
</style>
